
import { mapState } from 'vuex'
import {
  goartOpenApp
} from "~/utils/common";

export default {
  name: "OpenInApp",
  data () {
    return {
      pageData: this.$t("open_in_app")
    };
  },
  computed: {
    ...mapState({
      isInApp: state => state.mobile.isInApp,
      openInAppData: state => state.mobile.openInAppData,
    })
  },
  methods: {
    openUrl () {
      goartOpenApp({
        schema: this.openInAppData.schema,
      });
    }
  }
};
